import { Component, Inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatRipple } from '@angular/material/core';

@Component({
    selector: 'app-rename-trip-dialog',
    templateUrl: './rename-trip-dialog.component.html',
    styleUrls: ['./rename-trip-dialog.component.scss'],
    imports: [ReactiveFormsModule, MatRipple]
})
export class RenameTripDialogComponent {
  tripNameControl: FormControl<string> = new FormControl<string>('', [
    Validators.required,
    Validators.minLength(5),
    Validators.maxLength(50),
  ]);

  constructor(
    public dialogRef: MatDialogRef<RenameTripDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { name: string },
  ) {
    this.tripNameControl.setValue(this.data.name);
  }

  closeModal(res: boolean | string): void {
    this.dialogRef.close(res);
  }
}
